<template>
  <section class="container d-flex flex-column mt-3">
    <header>
      <span class="h6">
        <router-link to="/">Início</router-link>
        / {{ currentUniverse.name }}
      </span>

      <h3 v-if="showTitle" class="text-center my-3">
        {{ currentUniverse.name }}
      </h3>

      <img
        v-else
        :src="`/assets/img/universes/${currentUniverse.slug}.jpeg`"
        :alt="currentUniverse.name"
        class="img-fluid my-3"
      />
    </header>

    <component :is="universeComponent" :universe="currentUniverse" />
  </section>
</template>

<script>
import BelezaDasTrevas from '../components/universes/BelezaDasTrevas'
import EraSombria from '../components/universes/EraSombria'
import MaldicaoEterna from '../components/universes/MaldicaoEterna'
import SamuraisSeculoXXI from '../components/universes/SamuraisSeculoXXI'

export default {
  name: 'universe',

  inject: ['universes'],

  computed: {
    currentUniverse() {
      return this.universes.find(
        universe => universe.slug === this.$route.params.slug
      )
    },

    universeComponent() {
      switch (this.currentUniverse.slug) {
        case 'beleza-das-trevas':
          return BelezaDasTrevas
        case 'era-sombria':
          return EraSombria
        case 'maldicao-eterna':
          return MaldicaoEterna
        case 'samurais-seculo-xxi':
          return SamuraisSeculoXXI
        default:
          return null
      }
    },

    showTitle() {
      const universesWithBanner = [
        'beleza-das-trevas',
        'era-sombria',
        'maldicao-eterna',
        'samurais-seculo-xxi',
      ]
      if (universesWithBanner.includes(this.currentUniverse.slug)) return false
      return true
    },
  },
}
</script>
